import React, { useEffect, useState } from "react";
import DefaultMain from "layout";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { loanRequestContent } from "content/loan_request";

import { useDispatch, useSelector } from "react-redux";
import { GeneralLoanType } from "types/backend.modal";
import { RootState } from "store/configStore";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import images from "assets/images";
import { Helmet } from "react-helmet";
import LoanRequestForm from "pages/vse/components/VseForm";
import StepTwo from "pages/loan_request-mf/components/StepTwo";
import "../../style/components/_form-modal.scss";
import StepOne from "pages/loan_request-mf/components/StepOne";
import FormModal from "pages/loan_request-mf/components/FormModal";
import Success from "pages/loan_request-mf/components/success";
import Sorry from "pages/loan_request-mf/components/Sorry";
import ErrorContent from "pages/loan_request-mf/components/ErrorContent";
import TermsAndConditions from "pages/loan_request-mf/components/TermsAndConditions";

interface Props {
  type: GeneralLoanType;
  amountOfLoans: any[];
  API_getAmountsActionThunk: any;
  API_postFormActionThunk: any;
  API_ValidatePromoCodeActionThunk: any;
  API_GetLeadMarket: any;
  API_StepOneOCRActionThunk: any;
}

const RetailLoan: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const loc = useLocation();
  const { lang } = useSelector((state: RootState) => state.settingsReducer);
  const [success, setSuccess] = useState({ sent: false, error: false });
  const dispatch = useDispatch();

  const [isMainModalVisible, setIsMainModalVisible] = useState<boolean>(false);
  const [isSubModalVisible, setIsSubModalVisible] = useState<boolean>(false);
  const [subModalContent, setSubModalContent] = useState<
    "success" | "sorry" | "error" | "terms" | null
  >(null);
  const [titleAction, setTitleAction] = useState<"close" | "back">("close");
  const navigate = useNavigate();
  /**/
  const [step, setStep] = useState(1);
  const goToNextStep = () => setStep((prev) => prev + 1);
  const onBack = () => setStep((prev) => (prev > 1 ? prev - 1 : 1));
  const [checked, setChecked] = useState(false);
  const [selectedFrontImage, setSelectedFrontImage] = useState<string | null>(
    null
  );
  const [selectedBackImage, setSelectedBackImage] = useState<string | null>(
    null
  );
  const [fullName, setFullName] = useState<string>("");
  const [nationalID, setNationalID] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const vodafoneRedirected = searchParams.get("vodafoneRedirected") === "true";
  const hasPromoCode = searchParams.get("hasPromoCode") === "true";
  const [isSending, setIsSending] = useState<boolean>(false);
  const [isOrangeHovered, setIsOrangeHovered] = useState(false);
  const [isBlueHovered, setIsBlueHovered] = useState(false);
  let full_name_ocr = "";

  useEffect(() => {
    setSuccess({ sent: false, error: false });
  }, [loc.pathname]);


  const handleOCR = async (e: any) => {
    e.preventDefault();
    setIsSending(true);

    const resMessage: any = await dispatch(
      props.API_StepOneOCRActionThunk({
        FrontPhotoBasestring64: selectedFrontImage,
        BackPhotoBasestring64: selectedBackImage,
        MobileNumber: "01068952047",
        Lang: 0,
      })
    );
    setIsSending(false);
    if (resMessage.status == 200 && resMessage.data.ResultID == 0) {
      setNationalID(resMessage.data.ocr.result.front_nid);
      if (isAgeValid(resMessage.data.ocr.result.date_of_birth)) {
        goToNextStep();
        //
      } else {
        // props.setSuccess({ sent: true, error: true });
        setIsSubModalVisible(true);
        setSubModalContent("sorry");
      }

      full_name_ocr =
        resMessage.data.ocr.result.first_name +
        " " +
        resMessage.data.ocr.result.full_name;
      // navigate('/loan/thanks');
      setFullName(full_name_ocr);
      // props.setSuccess({ sent: true, error: false });
    } else {
      // props.setSuccess({ sent: true, error: true });
      setIsSubModalVisible(true);
      setSubModalContent("sorry");
    }
    // clearForm();
    return resMessage;
  };

  const isAgeValid = (dobString: string) => {
    const dateOfBirth = new Date(dobString); // Parse the date of birth
    const today = new Date(); // Current date

    // Calculate age
    const age = today.getFullYear() - dateOfBirth.getFullYear();
    const isBirthdayPassedThisYear =
      today.getMonth() > dateOfBirth.getMonth() ||
      (today.getMonth() === dateOfBirth.getMonth() &&
        today.getDate() >= dateOfBirth.getDate());

    // Adjust age if birthday hasn't passed this year
    const exactAge = isBirthdayPassedThisYear ? age : age - 1;

    // Check if the age is between 21 and 63 (inclusive)
    return exactAge >= 21 && exactAge <= 63;
  };

  const renderSubModalContent = () => {
    switch (subModalContent) {
      case "success":
        return (
          <Success
            setIsSubModalVisible={setIsSubModalVisible}
            setIsMainModalVisible={setIsMainModalVisible}
            setStep={setStep}
          />
        );
      case "sorry":
        return <Sorry setIsSubModalVisible={setIsSubModalVisible} />;
      case "error":
        return <ErrorContent setIsSubModalVisible={setIsSubModalVisible} />;
      case "terms":
        return <TermsAndConditions />;
      default:
        return null;
    }
  };
  const renderSubModalTitle = () => {
    switch (subModalContent) {
      case "success":
        return null;
      case "sorry":
        return null;
      case "error":
        return null;
      case "terms":
        return (
          <h1 className="loan-request-section-sub-modals-title">
            الشروط والأحكام
          </h1>
        );
      default:
        return null;
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <StepOne
            selectedBackImage={selectedBackImage}
            selectedFrontImage={selectedFrontImage}
            checked={checked}
            setChecked={setChecked}
            setSelectedBackImage={setSelectedBackImage}
            setSelectedFrontImage={setSelectedFrontImage}
            setIsSubModalVisible={setIsSubModalVisible}
            goToNextStep={goToNextStep}
            subModalContent={subModalContent}
            setSubModalContent={setSubModalContent}
            handleOCR={handleOCR}
          />
        );

        break;
      case 2:
        return (
          <StepTwo
            setSuccess={setSuccess}
            type={props.type}
            islamic={false}
            API_postFormActionThunk={props.API_postFormActionThunk}
            API_ValidatePromoCodeThunk={props.API_ValidatePromoCodeActionThunk}
            amountOfLoans={props.amountOfLoans}
            setSubModalContent={setSubModalContent}
            setIsSubModalVisible={setIsSubModalVisible}
            selectedBackImage={selectedBackImage}
            selectedFrontImage={selectedFrontImage}
            nationalID={nationalID}
            fullName={fullName}
            setFullName={setFullName}
            hrLoan={true}
          />
        );

      default:
        return null;
        break;
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {"Request Loan " + props.type + " - amanmicrofinance.com"}
        </title>
      </Helmet>

      <DefaultMain>
        <section className="loan-request-section hr-section hr-loan-request-form">
          <Row>
            <Col className="loan-request-form-container hr-request-form-container">
              {!success.sent ? (
                renderStep()
              ) : (
                <div className="success-form">
                  <div className="succes-form-icon-text">
                    <img
                      src={success.error ? images.errorSVG : images.successSVG}
                    />
                    <h3>
                      {success.error
                        ? t("An Error Occured Please try again")
                        : "تم تسجيل طلبك بنجاح"}
                    </h3>
                    {!success.error && (
                      <h3>عميلنا العزيز سيتم التواصل معك في أقرب وقت</h3>
                    )}{" "}
                  </div>
                  <button
                    onClick={() => {
                      if (success.error) {
                        setSuccess({ sent: false, error: false });
                      } else {
                        navigate("/");
                      }
                    }}
                    className="send-form-button"
                  >
                    {success.error ? "أعد المحاولة" : "الذهاب للصفحة الرئيسية"}
                  </button>
                  {!success.error && (
                    <>
                      <h3>شكرا لثقتك بامان</h3>
                    </>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </section>
      </DefaultMain>

      {isMainModalVisible && (
        <FormModal
          isVisible={isMainModalVisible}
          submitTitle={"التالى"}
          onClose={() => {
            setIsMainModalVisible(false);
          }}
          onBack={onBack}
          headerStyle={{ justifyContent: "unset" }}
          icon={titleAction}
        >
          {renderStep()}
        </FormModal>
      )}
      {isSubModalVisible && (
        <FormModal
          isVisible={isMainModalVisible}
          submitTitle={"حسنا"}
          title={renderSubModalTitle()}
          onClose={() => {
            setIsSubModalVisible(false);
          }}
          icon={"close"}
          isDisabled={false}
          containerStyle={{
            maxHeight: "550px",
            maxWidth: "600px",
          }}
        >
          {renderSubModalContent()}
        </FormModal>
      )}
    </>
  );
};
export default RetailLoan;
